<template>
  <div class="hgfarmer-proximity-container cs-scroll-style">
    <SpinnerContainer v-if="$store.state.appConfig.isLoading"/>
    <template v-if="dataSample && !$store.state.appConfig.isLoading">
      <div class="mt-3 mb-3 p-2" v-if="$store.state.appConfig.windowWidth < 769">
        <BackButton :clickMethod="back"/>
      </div>

      <div class="banner-padding">
        <div class="banner-container">
          <img :src="dataSample.bannerUrlMobile" class="banner-image" v-if="$store.state.appConfig.windowWidth < 769">
          <img :src="dataSample.bannerUrl" class="banner-image" v-else>
          <div class="title-overlay">{{ $tPop(dataSample.sourceCode, 'title',  dataSample.title) }}</div>
        </div>
      </div>
      <div class="proximity-container">
        <div class="proximity-container-item">
          <h5>{{ $tI('Description title') }}</h5>
          <hr/>
          <div>
            <p class="description" v-html="formattedDescription"></p>
          </div>
        </div>

        <div class="proximity-container-item">
          <h5>{{ $tI('Reference Samples title') }}</h5>
          <hr/>
          <div>
            <p class="description" v-html="formattedTextHTML(dataSample.referenceSamples)"></p>
          </div>
        </div>

        <div class="proximity-container-item">
          <h5>{{ $tI('Research Links title') }}</h5>
          <hr/>
          <ResearchLink :researchLinkContent="dataSample.researchLinks"/>
        </div>
      </div>
    </template>
</div>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  data() {
    return {
    };
  },
  methods: {
    back() {
      this.$store.state.hgFarmerResult.isOpenedHgFarmerDetail = false;
      this.$store.state.hgFarmerResult.openedHgFarmerDetail =  { id: 0, };
    },
    
    formattedTextHTML(text) {
      return text ? text.replace(/\n/g, '<br>') : '';
    },
  },
  computed: {
    dataSample() {
      return this.$store.state.hgFarmerResult.openedHgFarmerDetail;
    },  
    formattedDescription() {
      const description = this.$tPop(this.dataSample.sourceCode, 'description',  this.dataSample.description);
      return description ? description.replace(/\n/g, '<br>') : '';
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.hgfarmer-proximity-container {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  background-color: var(--white-100);
  .proximity-container {
    padding: 15px 28px 28px 28px;
  }
}

.banner-padding {
  padding: 10px;
}
.banner-container {
  position: relative;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  background-color: var(--white-100);

  .banner-image {
    width: 100%;
    height: 180px;
    height: auto;
    display: block;
  }

  .title-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    color: white;
    font-size: 24px;
    font-weight: bold;
    padding: 8px 10px;
    width: 100%;
    background: linear-gradient(180deg, rgba(92, 92, 92, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
    @media screen and (max-width: 769px) {
      font-size: 16px;
    }
  }
}

</style>